import { Flex } from 'antd';
import { Container, TabHeader, TabHeaderItem } from './style';
import { ReactNode, useEffect, useState } from 'react';

export interface TabProps {
  tabs: {
    id: string | number;
    title: string;
    component: ReactNode;
  }[];
  defaultActiveTab?: string | number;
}

const Tab = ({ tabs, defaultActiveTab }: TabProps) => {
  const [activeTab, setActiveTab] = useState<any>();

  useEffect(() => {
    setActiveTab(defaultActiveTab || tabs[0].id);
  }, [defaultActiveTab]);

  return (
    <Container>
      <TabHeader>
        {tabs.map((i) => (
          <TabHeaderItem
            key={i.id}
            className={i.id === activeTab ? 'active' : ''}
            onClick={() => setActiveTab(i.id)}
          >
            <div className="title">{i.title}</div>
          </TabHeaderItem>
        ))}
      </TabHeader>
      {tabs.find((t) => t.id === activeTab)?.component}
    </Container>
  );
};

export default Tab;
